<canvas #avatar height="300" width="300" class="hidden"></canvas>
<div class="animal-container" #compositionContainer>
  <canvas id="monavatar" #composition></canvas>
</div>